import gsap, { Power3, Power4 } from 'gsap';
import _Sidemenu from '../_app/cuchillo/layout/Sidemenu';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Ease } from '../_app/cuchillo/utils/Ease';
import Header from './Header';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';

export default class Sidemenu extends _Sidemenu {
  static holder = GetBy.class('holder', this.container)[0];
  static fakeButton = GetBy.id("SidemenuClose");

  static size = {
    open:0,
    height:0,
    scroll:0,
    delta:0
  };

  static get height() {
    return this.size.height;
  }
  static set height(__height) {
    this.size.height = __height;
    document.body.style.setProperty('--sidemenu-height', `${this.size.height}px`);
  }

  static init () {
    Sidemenu.directHide();
  }

  static loop() {
    /*const DELTA = -(Scroll.y) - this.size.scroll;
    this.size.scroll = -Scroll.y;
    this.size.delta = this.size.delta + DELTA;
    document.body.style.setProperty('--sidemenu-scroll-delta', `${this.size.delta}px`);*/
  }
  
  static resize() {
    this.size.open = this.holder.offsetHeight;
  }

  static show__effect(__d = 0) {
    this.fakeButton.style.display = "block";
    gsap.to(this, { height:this.size.open, duration:.7, ease: Ease.EASE_CUCHILLO_OUT, delay:.0,
      onComplete: () => {
        this.afterShow();
      }
    });
  }

  static hide__effect(__d = 0) {
    this.fakeButton.style.display = "none";
    gsap.to(this, { height:0, duration:.4, ease: Power4.easeOut, delay:.0,
      onComplete: () => {
        this.afterHide();
      }
    });
  }

  static directHide() {
    this.height = 0;
    this._state = Sidemenu.STATE_CLOSE;
    this.afterHide();
  }
}
